var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchipelagosLabsPerformanceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000034768154521967726830000007100695058455816344_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.7,3.7H1.3C0.8,3.7,0.5,4,0.5,4.5v61.1c0,0.4,0.3,0.7,0.8,0.8h67.5c0.4,0,0.8-0.3,0.8-0.8V4.4 C69.5,4,69.2,3.7,68.7,3.7z M68,5.2v9.6H2V5.2H68z M2,64.8V16.3h66v48.4H2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.5,9.2h2.4v2.3H6.5V9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,9.2h2.4v2.3h-2.4V9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.2,9.2h2.4v2.3h-2.4V9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,23.9C21.7,24,11,34.7,11,48c0,0.4,0.3,0.8,0.7,0.8c0,0,0,0,0,0c0.4,0,0.8-0.3,0.8-0.8 c0-12.4,10.1-22.5,22.5-22.5c12.4,0,22.5,10.1,22.5,22.5c0,0,0,0,0,0c-0.1,0.4,0.2,0.8,0.7,0.9s0.8-0.2,0.9-0.7c0-0.1,0-0.1,0-0.2 C59,34.7,48.3,24,35,23.9C35,23.9,35,23.9,35,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.7,34.6l-9.4,13c-0.2,0.4-0.1,0.8,0.2,1.1c0.1,0.1,0.3,0.1,0.4,0.1c0.2,0,0.5-0.1,0.6-0.3l9.4-13 c0.3-0.3,0.2-0.8-0.1-1.1c0,0,0,0,0,0C44.4,34.1,44,34.2,43.7,34.6C43.7,34.5,43.7,34.5,43.7,34.6L43.7,34.6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchipelagosLabsPerformanceIcon);
export default __webpack_public_path__ + "static/media/Archipelagos_Labs-PerformanceIcon.53a6e4a5152ae20195c07e5997164d7d.svg";
export { ForwardRef as ReactComponent };